/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Sim_AriaInputs */

const es_landing_sim_aria = /** @type {(inputs: Landing_Sim_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver desglose del simulador de precio`)
};

const gl_landing_sim_aria = /** @type {(inputs: Landing_Sim_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver desglose do simulador de prezo`)
};

const en_landing_sim_aria = /** @type {(inputs: Landing_Sim_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View price simulator breakdown`)
};

/**
* | output |
* | --- |
* | "View price simulator breakdown" |
*
* @param {Landing_Sim_AriaInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_sim_aria = /** @type {((inputs?: Landing_Sim_AriaInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Sim_AriaInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_sim_aria(inputs)
	if (locale === "en") return en_landing_sim_aria(inputs)
	return es_landing_sim_aria(inputs)
});